
  import { mapState } from 'vuex'
  export default {
    data() {
      return {
        paymentType: null,
        steppers: 1,
        forceToAddBankAccountModal: false,
        disabledToDeposit: false,
        disabledBank: true,
        disabledThirdParty: true,
        disabledCrypto: true,
        receiverBankInfo: {}
      }
    },
    computed: {
      ...mapState({
        player: state => state.player.player,
        depositFlow: state => state.themes.deposit.depositFlow,
        checkExist: state => state.themes.deposit.checkExist,
        checkDeposit: state => state.themes.deposit.checkDeposit,
        playerCryptoWallets: state => state.themes['player-bank'].playerCryptoWallets
      }),
      depositType() {
        if (!this.depositFlow.deposit_type) return null
        return ~~this.depositFlow.deposit_type
      },
      showBankPayment() {
        if (this.depositType === 1) return false
        return this.depositFlow.is_bank_transfer_enabled
      },
      showOnlinePayment() {
        if (this.depositType === 1) return false
        return this.depositFlow.is_third_party_payment_enabled
      },
      showCryptoCurrency() {
        if (this.depositType === 1) return false
        return this.depositFlow.is_crypto_payment_enabled
      }
    },
    watch: {
      player(value) {
        this.checkWebsiteSettings()
      },
      depositFlow(value) {
        // Do not change any Active Payment Buttons if the user has already selected a Payment Type Button
        if (!this.paymentType) {
          if (value?.is_bank_transfer_enabled) {
            this.paymentType = 'bank'
          } else if (value?.is_third_party_payment_enabled) {
            this.paymentType = 'online'
          } else if (value?.is_crypto_payment_enabled) {
            this.paymentType = 'crypto'
          }
        }
        // only international
        if (!this.operationSettingCheckCrypto) {
          const hasBankAccount = this.player.has_bank_account
          if (
            hasBankAccount === false &&
            ~~value?.reg_flow === 3 &&
            (value?.is_bank_transfer_enabled || this.is_third_party_payment_enabled)
          ) {
            this.forceToAddBankAccountModal = true
            this.disabledToDeposit = true
          } else if (hasBankAccount === false) {
            this.forceToAddBankAccountModal = true
            this.disabledToDeposit = true
          } else {
            this.disabledToDeposit = false
          }
        }
      },
      checkExist(value) {
        if (value?.is_exist) {
          this.enableDisabledPaymentMethod(value)
        }
      },
      checkDeposit(value) {
        if (value) {
          this.disabledBank = true
          this.disabledThirdParty = true
          this.disabledCrypto = true
        }
      }
    },
    async mounted() {
      // check if crypto are existing or not
      await this.$store.dispatch('themes/player-bank/playerCryptoWallet')
      this.checkWebsiteSettings()
      this.isExit()
      // execute only lao wl
      // if (!this.isInternational) {
      //     this.$store.dispatch(
      //         'themes/deposit/depositFlow',
      //         this.$cookie.get('player')?.currency
      //     )
      // }
      // execute only inter wl
      this.$store.dispatch('settings/operationSetting', this.$cookie.get('player')?.currency)

      // unsubscribe vuex mutation
      this.subscribeAction = this.$store.subscribeAction((mutation, state) => {
        if (
          mutation.type === 'sockets/revokeDepositByAdmin' ||
          mutation.type === 'sockets/confirmDepositByAdmin' ||
          mutation.type === 'sockets/successfulDeposit'
        ) {
          this.isExit()
        }
      })
    },
    beforeDestroy() {
      // unsubscribe the store action
      if (this.subscribeAction) {
        this.subscribeAction()
      }
    },
    methods: {
      // check website settings conditions
      checkWebsiteSettings() {
        const hasBankAccount = this.player.has_bank_account
        const registrationType = this.player.registration_type

        if (
          hasBankAccount === false &&
          registrationType === 3 &&
          (this.depositFlow.is_bank_transfer_enabled ||
            this.depositFlow?.is_third_party_payment_enabled)
        ) {
          this.forceToAddBankAccountModal = true
          this.disabledToDeposit = true
        } else if (hasBankAccount === false && ~~registrationType !== 5) {
          this.forceToAddBankAccountModal = true
          this.disabledToDeposit = true
        } else {
          this.disabledToDeposit = false
        }
      },
      async isExit() {
        const isExist = await this.$store.dispatch('themes/deposit/checkExist')
        this.enableDisabledPaymentMethod(isExist)
      },
      enableDisabledPaymentMethod(data) {
        if (data && data.is_exist === true && data.payment_provider_code === 'manual_transfer') {
          this.paymentType = 'bank'
          this.disabledBank = false
          this.disabledThirdParty = true
          this.disabledCrypto = true
        } else if (data && data.is_exist === true && data.payment_provider_code === 'crypto') {
          this.paymentType = 'crypto'
          this.disabledBank = true
          this.disabledThirdParty = true
          this.disabledCrypto = false
        } else if (data && data.is_exist === true && data.payment_provider_code === 'third_party') {
          this.paymentType = 'online'
          this.disabledBank = true
          this.disabledThirdParty = false
          this.disabledCrypto = true
        } else {
          this.disabledBank = false
          this.disabledThirdParty = false
          this.disabledCrypto = false
        }
      },
      bankTransferConfirm(value = true) {
        this.disabledThirdParty = value
        this.disabledCrypto = value
      },
      cryptoTransferConfirm(value = true) {
        this.disabledThirdParty = value
        this.disabledBank = value
      },
      onlinePaymentConfirm(value = true) {
        this.disabledCrypto = value
        this.disabledBank = value
      },
      onClickBannerDeposit(link) {
        if (!link) return
        window.open(this.fixUrlProtocol(link), '_blank')
      },
      fixUrlProtocol(url) {
        if (!url.startsWith('http://') && !url.startsWith('https://')) {
          url = 'https://' + url
        }
        return url
      }
    }
  }
